// Can this browser actually reach Firebase?
//
// navigator.onLine is useless for the case that prompted this: a VPN or
// filtering proxy is very much "online" while silently refusing
// googleapis.com. The app then loads its own HTML from tastr.app perfectly,
// gets nothing from Firestore, and renders an EMPTY feed -- indistinguishable
// from a site with no recipes. Reported as "the app doesn't work", which is
// exactly what it looks like.
//
// mode:'no-cors' is what makes this work. A normal fetch to firestore
// .googleapis.com fails CORS, and a CORS failure throws the same TypeError a
// blocked host does -- so a plain fetch cannot tell "blocked" from "worked
// but wouldn't share the response". A no-cors fetch resolves with an opaque
// response whenever the bytes made it back, and rejects only on a genuine
// connection failure.
//
// This deliberately does NOT diagnose. It answers one question -- can we
// reach the database at all -- so the UI can say so. scripts/net_diagnostic.js
// is the tool for working out which host and why.

const FIRESTORE_HOST = 'https://firestore.googleapis.com';
const TIMEOUT_MS = 8000;

export async function isFirebaseReachable({ timeoutMs = TIMEOUT_MS } = {}) {
  if (typeof fetch !== 'function') return true; // can't tell; assume fine

  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeoutMs);
  try {
    await fetch(FIRESTORE_HOST, {
      mode: 'no-cors',
      cache: 'no-store',
      signal: controller.signal
    });
    return true;
  } catch (_) {
    // Aborted or refused. Either way the user is not getting their data.
    return false;
  } finally {
    clearTimeout(timer);
  }
}
